export default {
  BusinessLogisticsProductLang: {
    productCode: 'Product Code',
    productName: 'Product Name',
    scanNode: 'Waybill Number Fetch Stage',
    productType: 'Product Type',
    orderType: 'Order Type',
    status: 'Status',
    departurePortCity: 'Departure Port City',
    specialGoodsType: 'Special Goods Type',
    weightUnit: 'Weight Unit',
    lengthUnit: 'Length Unit',
    sortNum: 'Sort Order',
    deliveryDays: 'Transit Time Description',
    waybillSource: 'Waybill Source',
    sheetType: 'Shipping Label Type',
    operation: 'Action',
    addProduct: 'Add Product',
    editProduct: 'Edit Product',
    productEdit: 'Product Settings',
    supplier: 'Supplier',
    createdOn: 'Created Time',
    basicInfo: 'Basic Information',
    goodsConfig: 'Item Configuration',
    businessConfig: 'Business Configuration',
    otherConfig: 'Other Configuration',
    productCodePlaceholder: 'Leave blank to auto-generate',
    productNamePlaceholder: 'Please enter product name',
    allowModifyOrder: 'Allow Order Modification',
    arrearsStopService: 'Suspend Service for Overdue Payment',
    generalGoods: 'General Cargo',
    innerBattery: 'Built-in Battery',
    pureBattery: 'Standalone Battery',
    magnetic: 'Magnetic Goods',
    liquid: 'Liquid',
    powder: 'Powder',
    kilogram: 'Kilogram',
    centimeter: 'Centimeter',
    arrivalScanNode: 'Acquired upon Port Arrival',
    inboundScanNode: 'Acquired after Warehousing',
    scanNodeTips: 'Cannot be changed after setup. Please set carefully.',
    orderTypeTips: 'Cannot be changed after setup. Please set carefully.',
    smallPackage: 'Parcel / Small Package',
    express: 'Express',
    fba: 'FBA (Fulfillment by Amazon)',
    minDeliveryDays: 'Minimum Transit Time (Days)',
    maxDeliveryDays: 'Maximum Transit Time (Days)',
    minDeliveryDaysPlaceholder: 'Please enter minimum days',
    maxDeliveryDaysPlaceholder: 'Please enter maximum days',
    dayUnit: 'Day(s)',
    businessChannel: 'Select Service Channel',
    businessChannelPlaceholder: 'Please select service channel',
    maxDeliveryDaysLessThanMin: 'Maximum transit time cannot be less than minimum transit time',
    productRules: 'Product Rules',
    labelRules: 'Shipping Label Rules',
    deliveryTrackingNumberSettings: 'Delivery Tracking Number Settings',
    zones: 'Zone',
    trackingDataFetchSettings: 'Tracking Fetch Settings',
    serviceZone: 'Service Zone',
    remoteZone: 'Remote Zone',
  },
};
